export default "__VITE_ASSET__CV9nITIk__"